module.exports = __webpack_public_path__ + "static/media/social.82c951da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/social.svg
// module id = 650
// module chunks = 36